import React, { useContext } from 'react';
import { Context } from '../../context/news_search.context';
import { TrendingNewsTopic, SortingOption } from '../../types/news_search.types';
import { SORTING_OPTIONS } from '../../constants/news_search.constants';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import classNames from 'classnames';
import styles from './sort_filter.module.scss';
import './sort_filter.global_styles.scss';

const SortFilter: React.FC = () => {
  const { trendingNewsTopics, sortingField, setSortingField, setPageNumber, query } =
    useContext(Context);

  const sortingFilterTitle = query ?
    SORTING_OPTIONS.find((option: SortingOption): boolean => option.value === sortingField).display
    : 'Publication date';

  return (
    <div className='container mb-48'>
      <div className='row'>
        <div className='col-xs-12 col-lg-9 pt-15 mb-15 mb-lg-0'>
          <i className={`me-2 icon-satellite-dish fal ${styles.Icon}`} />
          {trendingNewsTopics.map(
            (topic: TrendingNewsTopic, index: number): JSX.Element => (
              <h2
                className='d-inline-block fs-6 mb-0 fw-bold' key={index}>
                <a
                  className={classNames(
                    'px-25 btn-link link-blue-orange lh-lg',
                    index !== 0 && styles.TopicBorder,
                  )}
                  href={topic.url}
                >
                  {topic.title}
                </a>
              </h2>
            )
          )}
        </div>
        <div className='col-xs-12 col-lg-3 mt-3 mt-lg-0'>
          <div className='devex-react-bootstrap-dropdown-overwrite'>
            <DropdownButton
              className='d-grid'
              disabled={!query}
              id='sorting-filter-dropdown'
              variant='secondary'
              title={`Sort by: ${sortingFilterTitle}`}
            >
              {SORTING_OPTIONS.map(
                (option: SortingOption): JSX.Element => (
                  <Dropdown.Item
                    key={option.display}
                    onClick={() => {
                      setPageNumber(1);
                      setSortingField(option.value);
                    }}
                  >
                    {option.display}
                  </Dropdown.Item>
                )
              )}
            </DropdownButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortFilter;
